import React from 'react'
import PropTypes from 'prop-types'
import CarouselCard from './CarouselCard'
import './AloCarousel.scss'

class AloCarousel extends React.Component {
  constructor (props) {
    super(props)

    this.totalNumberOfItemsPerPage = props.numberPerItemOnPage.reduce(
      (total, num) => total + num
    )
    this.numberOfMarginSpaces = this.totalNumberOfItemsPerPage - 1
    this.heightRatio = this.getHeightSizeRatio()
    this.indexOfMostLeftCard = 0
    this.currCarouselPos = 0

    this.state = {
      disablePrev: true,
      disableNext: false,
      draggable: false,
      mouseDownPos: 0,
      disableCarousel: false
    }

    this.carouselContainer = React.createRef()
    this.carousel = React.createRef()

    this.getHeightSizeRatio = this.getHeightSizeRatio.bind(this)
    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.resetCarousel = this.resetCarousel.bind(this)
    this.renderNavButton = this.renderNavButton.bind(this)
    this.shiftCardsToRight = this.shiftCardsToRight.bind(this)
    this.shiftCardsToLeft = this.shiftCardsToLeft.bind(this)
    this.enableLinks = this.enableLinks.bind(this)
    this.disableLinks = this.disableLinks.bind(this)
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this)
  }

  componentDidMount () {
    this.carouselContainer.current.style.paddingLeft = `${
      this.props.leftPadding
    }px`

    window.onresize = () => {
      const windowWidth = window.innerWidth - this.props.leftPadding
      const height =
        this.heightRatio *
          (windowWidth - this.numberOfMarginSpaces * this.props.margin) +
        this.props.extraItemHeight

      this.totalCarouselWidth = 0
      this.cards = this.carousel.current.querySelectorAll('.CarouselCard')
      this.cards.forEach(card => {
        const cardRatioIdx = card.getAttribute('data-ratio-idx')
        const cardRatio = this.props.sizeRatioOfItems[cardRatioIdx]
        const cardWidth = cardRatio * (height - this.props.extraItemHeight)
        card.style.width = `${cardWidth}px`
        this.totalCarouselWidth += cardWidth + this.props.margin
      })
      this.carousel.current.style.width = `${this.totalCarouselWidth}px`

      if (
        this.totalCarouselWidth < this.carouselContainer.current.clientWidth
      ) {
        this.setState({ disableCarousel: true })
      }
    }
  }

  handleMouseDown (e) {
    e.preventDefault()

    // 2 is mouse event code for right click
    if (e.button !== 2 && !this.state.disableCarousel) {
      this.setState({
        mouseDownPos: e.clientX,
        draggable: true
      })
    }
  }

  handleMouseMove (e) {
    e.preventDefault()
    if (this.state.draggable && !this.state.disableCarousel) {
      this.disableLinks()
      const distanceTravelled = e.clientX - this.state.mouseDownPos
      this.carousel.current.style.transform = `translateX(${distanceTravelled +
        this.currCarouselPos}px)`
      this.carousel.current.style.transitionDuration = '0s'

      const leftMostCard = this.cards[this.indexOfMostLeftCard]
      if (
        leftMostCard.getBoundingClientRect().left < this.props.leftPadding &&
        this.indexOfMostLeftCard < this.cards.length
      ) {
        this.indexOfMostLeftCard++
      } else if (
        this.indexOfMostLeftCard > 1 &&
        this.cards[this.indexOfMostLeftCard - 1].getBoundingClientRect().left >
          0
      ) {
        this.indexOfMostLeftCard--
      }
      if (
        this.carousel.current.getBoundingClientRect().left +
          this.carousel.current.clientWidth <
        this.carouselContainer.current.clientWidth
      ) {
        this.setState({
          disableNext: true
        })
      } else {
        this.setState({
          disableNext: false
        })
      }
    }
  }

  handleMouseUp (e) {
    e.preventDefault()
    if (this.state.draggable && !this.state.disableCarousel) {
      const carousel = this.carousel.current
      const carouselContainer = this.carouselContainer.current
      const carouselLeftPos = carousel.getBoundingClientRect().left
      const carouselContainerLeft = carouselContainer.getBoundingClientRect()
        .left

      this.currCarouselPos += e.clientX - this.state.mouseDownPos

      const lastCard = this.cards[this.cards.length - 1]
      const lastCardRightPos =
        lastCard.getBoundingClientRect().left + lastCard.clientWidth

      let disablePrev
      let disableNext
      if (carouselLeftPos > carouselContainerLeft) {
        this.currCarouselPos = 0 // Reset Carousel
        this.indexOfMostLeftCard = 0
        this.resetCarousel()
        disableNext = false
        disablePrev = true
      } else if (
        lastCardRightPos < this.carouselContainer.current.clientWidth
      ) {
        const distanceToTravelRight =
          this.carouselContainer.current.clientWidth - lastCardRightPos
        this.currCarouselPos += distanceToTravelRight
        disablePrev = false
        disableNext = true
        this.resetCarousel(this.currCarouselPos)

        const carouselAnimationTime = 250
        setTimeout(() => {
          let newIndexOfMostLeftCard
          this.cards.forEach((card, idx) => {
            if (card.getBoundingClientRect().left > 0) {
              if (!newIndexOfMostLeftCard) {
                newIndexOfMostLeftCard = idx
              }
            }
          })
          this.indexOfMostLeftCard = newIndexOfMostLeftCard
        }, carouselAnimationTime)
      }

      this.setState({
        draggable: false,
        disablePrev,
        disableNext
      })

      setTimeout(this.enableLinks)
    }
  }

  disableLinks () {
    this.carousel.current.querySelectorAll('a').forEach(link => {
      link.onclick = e => {
        e.preventDefault()
      }
    })
  }

  enableLinks () {
    this.carousel.current.querySelectorAll('a').forEach(link => {
      link.onclick = () => {}
    })
  }

  resetCarousel (pos = 0) {
    const carousel = this.carousel.current
    carousel.style.transform = `translateX(${pos}px)`
    carousel.style.transitionDuration = '0.25s'
  }

  getHeightSizeRatio () {
    let ratio = 0
    this.props.numberPerItemOnPage.forEach((amountOfItem, idx) => {
      ratio += amountOfItem * this.props.sizeRatioOfItems[idx]
    })
    return 1 / ratio
  }

  shiftCarousel () {
    this.carousel.current.style.transform = `translateX(${
      this.currCarouselPos
    }px)`
    this.carousel.current.style.transitionDuration = '0.25s'
  }

  shiftCardsToRight () {
    if (!this.state.disableNext) {
      const cardToMove = this.cards[this.indexOfMostLeftCard + 1]
      const distanceToTranslate =
        cardToMove.getBoundingClientRect().left - this.props.leftPadding
      this.currCarouselPos -= distanceToTranslate
      this.setState({ disablePrev: false }, () => {
        this.indexOfMostLeftCard++
        this.shiftCarousel()
      })
    }
  }

  shiftCardsToLeft () {
    if (!this.state.disablePrev) {
      const cardToMove = this.cards[this.indexOfMostLeftCard - 1]
      const distanceToMove =
        this.props.leftPadding - cardToMove.getBoundingClientRect().left
      this.currCarouselPos += distanceToMove
      this.indexOfMostLeftCard--
      this.shiftCarousel()
    }
  }

  renderNavButton () {
    if (!this.state.disableCarousel) {
      return (
        <React.Fragment>
          <div
            className={`AloCarousel__nav AloCarousel__nav--prev ${
              this.state.disablePrev
                ? 'AloCarousel__nav--disabled'
                : 'AloCarousel__nav--active'
            }`}
            onClick={this.shiftCardsToLeft}
          />
          <div
            className={`AloCarousel__nav AloCarousel__nav--next ${
              this.state.disableNext
                ? 'AloCarousel__nav--disabled'
                : 'AloCarousel__nav--active'
            }`}
            onClick={this.shiftCardsToRight}
          />
        </React.Fragment>
      )
    }
  }

  handleTransitionEnd () {
    const lastCard = this.cards[this.cards.length - 1]
    const lastCardRightPos =
      lastCard.getBoundingClientRect().left + lastCard.clientWidth

    const disableNext =
      lastCardRightPos <
      this.carouselContainer.current.clientWidth + this.props.leftPadding
    const disablePrev = this.indexOfMostLeftCard === 0

    this.setState({
      disableNext,
      disablePrev
    })
  }

  render () {
    let carouselItems = this.props.items.map((item, idx) => (
      <CarouselCard
        ratioIdx={item.ratioIdx}
        key={idx}
        margin={this.props.margin}
      >
        {item.element}
      </CarouselCard>
    ))
    return (
      <div className='AloCarousel' ref={this.carouselContainer}>
        <div
          className='AloCarousel__carousel'
          ref={this.carousel}
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handleMouseUp}
          onTransitionEnd={this.handleTransitionEnd}
        >
          {carouselItems}
        </div>
        {this.renderNavButton()}
      </div>
    )
  }
}

AloCarousel.defaultProps = {
  leftPadding: 0
}

AloCarousel.propTypes = {
  leftPadding: PropTypes.number,
  margin: PropTypes.number,
  numberPerItemOnPage: PropTypes.array,
  sizeRatioOfItems: PropTypes.array,
  extraItemHeight: PropTypes.number,
  items: PropTypes.array
}

export default AloCarousel
